var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headlineTag,{tag:"component",staticClass:"headline",class:[
    ("headline--size-" + _vm.size),
    { 'headline--center': _vm.center },
    { 'headline--desktop-fluid': _vm.desktopFluid },
    ("headline--color-" + _vm.color),
    { 'headline--underline': _vm.underlined }
  ]},[_c('span',{staticClass:"headline__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }